/**
 * Stripe.js loader.
 *
 * The publishable key is public by design — it identifies the account and can
 * only create payment methods, never move money. It still comes from config
 * rather than being hard-coded so test and live keys are a deploy setting.
 *
 * loadStripe is called once at module scope: it injects a script tag, and
 * calling it per-render would add one on every mount.
 */

import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../config/env';

let stripePromise: Promise<Stripe | null> | null = null;

/** Null when no publishable key is configured — callers must handle that. */
export function getStripe(): Promise<Stripe | null> | null {
  if (!STRIPE_PUBLISHABLE_KEY) return null;
  stripePromise ??= loadStripe(STRIPE_PUBLISHABLE_KEY);
  return stripePromise;
}

export const isStripeConfigured = Boolean(STRIPE_PUBLISHABLE_KEY);

/** True for a test-mode key, so the UI can say so plainly. */
export const isStripeTestMode = STRIPE_PUBLISHABLE_KEY.startsWith('pk_test_');
